import {Button} from '@primer/react'
import {clsx} from 'clsx'
import styles from './grid-cells/ActionBar.module.css'
import {InProgressCommentIndicator} from './InProgressCommentIndicator'
import {PlusIcon} from '@primer/octicons-react'
import {getGlobalINPObserver} from '@github-ui/web-vitals'
import {useAnalytics} from '@github-ui/use-analytics'
import {sendCustomMetric} from '@github-ui/stats'

export function SimpleAddCommentButton({
  hasDraftComment,
  lineSpacingPreference,
  openStartConversationDialog,
  authorLogin,
  authorAvatarUrl,
}: {
  hasDraftComment: boolean | undefined
  lineSpacingPreference: 'compact' | 'relaxed'
  openStartConversationDialog: () => void
  authorLogin: string
  authorAvatarUrl: string
}) {
  const {sendAnalyticsEvent} = useAnalytics()
  return (
    <div aria-hidden={false} className={clsx('d-flex', 'flex-row', styles.addCommentButton)}>
      {hasDraftComment ? (
        <Button
          aria-label="Continue comment in progress"
          size="small"
          className={clsx(
            'py-0',
            lineSpacingPreference === 'compact'
              ? styles.addCommentButtonDraftCompact
              : styles.addCommentButtonDraftRelaxed,
            styles.actionBarHeight,
          )}
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            getGlobalINPObserver()?.registerCallback({
              event: e.nativeEvent,
              cb: interaction => {
                sendAnalyticsEvent('diff-lines.inp_interaction', 'CELL_ADD_COMMENT_BUTTON', {
                  latency: interaction.latency,
                })
                sendCustomMetric({
                  name: 'PRS_ADD_COMMENT_BUTTON_CLICK',
                  tags: {diffType: 'v2'},
                  value: interaction.latency,
                })
              },
            })
            openStartConversationDialog()
          }}
        >
          <InProgressCommentIndicator
            lineSpacingPreference={lineSpacingPreference}
            authorAvatarUrl={authorAvatarUrl}
            authorLogin={authorLogin}
          />
        </Button>
      ) : (
        <Button
          icon={PlusIcon}
          aria-label="Add comment"
          size="small"
          data-add-comment-button
          className={clsx(
            'fgColor-muted',
            'bgColor-accent-emphasis',
            'borderColor-accent-emphasis',
            'fgColor-onEmphasis',
            'px-0',
            styles.addCommentButtonNew,
            styles.actionBarHeight,
            styles.actionBarStartCommentWidth,
          )}
          onClick={openStartConversationDialog}
        />
      )}
    </div>
  )
}

try{ SimpleAddCommentButton.displayName ||= 'SimpleAddCommentButton' } catch {}